export default __webpack_public_path__ + "static/media/ps-icon-disable.4c0e9e7f.svg";